<p-tabView class="height100p height100p full-height direct-sub" [(activeIndex)]="activeIndex">
    <p-tabPanel header="Templates">
        <sm-table2 *ngIf="tableTemplateProfiling != null" class="height100p" [data]="tableTemplateProfiling" [flashChanges]=true (onCellValueChanged)="editTemplateProfilingCell($event)" (onCellClicked)="clickTemplateProfilingCell($event)"></sm-table2>
    </p-tabPanel>
    <p-tabPanel header="Worker">
        <div class="flex-col height100p">
            <sm-toolbar class="flex-item-fixed">
                <p-checkbox class="mr-3" label="Aktualisieren" name="workerProfilingRefresh" [(ngModel)]="workerProfilingRefresh" [binary]="true"></p-checkbox>
                <p-checkbox class="mr-3" label="Gruppiere nach Objekt" name="workerProfilingGroupObject" [(ngModel)]="workerProfilingGroupObject" [binary]="true" (ngModelChange)="fillWorkerProfilingTable()"></p-checkbox>
                <p-checkbox label="Gruppiere nach Worker" name="workerProfilingGroupWorker" [(ngModel)]="workerProfilingGroupWorker" [binary]="true" (ngModelChange)="fillWorkerProfilingTable()"></p-checkbox>
            </sm-toolbar>
            <sm-table2 *ngIf="tableWorkerProfiling != null" class="flex-item-fill height100p" [data]="tableWorkerProfiling" [flashChanges]=true></sm-table2>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Server API">
        <div class="flex-col height100p">
            <sm-toolbar class="flex-item-fixed">
                <p-checkbox class="mr-3" label="Aktualisieren" name="enaioCallsProfilingRefresh" [(ngModel)]="enaioCallsProfilingRefresh" [binary]="true"></p-checkbox>
                <p-checkbox label="Gruppiere nach Parametern" name="enaioCallsProfilingGroupParams" [(ngModel)]="enaioCallsProfilingGroupParams" [binary]="true" (ngModelChange)="fillEnaioCallsProfilingTable()"></p-checkbox>
            </sm-toolbar>
            <sm-table2 *ngIf="tableEnaioCallsProfiling != null" class="flex-item-fill height100p" [data]="tableEnaioCallsProfiling" [flashChanges]=true></sm-table2>
        </div>
    </p-tabPanel>
    <p-tabPanel header="SQL">
        <div class="flex-col height100p">
            <sm-toolbar class="flex-item-fixed">
                <p-checkbox class="mr-3" label="Aktualisieren" name="sqlProfilingRefresh" [(ngModel)]="sqlProfilingRefresh" [binary]="true"></p-checkbox>
            </sm-toolbar>
            <sm-table2 *ngIf="tableSqlProfiling != null" class="flex-item-fill height100p" [data]="tableSqlProfiling" [flashChanges]=true></sm-table2>
        </div>
    </p-tabPanel>
</p-tabView>
